import { render, staticRenderFns } from "./UserInviteDialog.vue?vue&type=template&id=1bf71bf0"
import script from "./UserInviteDialog.vue?vue&type=script&lang=js"
export * from "./UserInviteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports